import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Router } from '@angular/router';
import { APIEndpoint } from '../appsettings/BaseUrl';


@Injectable()
export class NotificationServiceCustom {
  
  private BASE_URL: string;
  _headers:any;
  constructor(private http:HttpClient, private _router:Router) {
    this.BASE_URL = APIEndpoint.BaseUrl;
    this._headers= new HttpHeaders({
    'Client-Service': 'LRL2018SH',
    'Auth-Key': '5ccd7b534b19d30030c6503f3a852d00',
    'Content-Type': 'application/json'
  })
}

  SendNotification(data):Observable<any>
  {
    const url = this.BASE_URL + 'send-notification';
    return this.http.post(url,data,{headers:this._headers}).map(res=>res).catch((e:any)=>{
      return Observable.throw(e);
    });
  }
  GetAllNotifications():Observable<any>
  {
    const url = this.BASE_URL + 'notification-list';
    return this.http.post(url,{},{headers:this._headers}).map(res=>res).catch((e:any)=>{
      return Observable.throw(e);
    });
  }

  GetCircularList():Observable<any>
  {
    const url = this.BASE_URL + 'circular-list';
    return this.http.post(url,{},{headers:this._headers}).map(res=>res).catch((e:any)=>{
      return Observable.throw(e);
    });

  }
  SearchCircular(id):Observable<any>
  {
    const url = this.BASE_URL + 'update-circular';
    return this.http.post(url,{id:id},{headers:this._headers}).map(res=>res).catch((e:any)=>{
      return Observable.throw(e);
    });

  }
  UpdateCircular(id):Observable<any>
  {
    const url = this.BASE_URL + 'update-circular';
    return this.http.post(url,{id:id},{headers:this._headers}).map(res=>res).catch((e:any)=>{
      return Observable.throw(e);
    });

  }

  WriteToSchool():Observable<any>
  {
    const url = this.BASE_URL + 'write-to-school';
    return this.http.post(url,{},{headers:this._headers}).map(res=>res).catch((e:any)=>{
      return Observable.throw(e);
    })

  }

  
}